export class ArrayExtensions {
  static toStringWithSemicolons(arr: (string | number)[]): string {
    return arr.map(item => item.toString()).join(";");
  }
}